import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@questlabs/react-sdk/dist/style.css';
import Layout from './components/Layout';
import Config from './pages/Config';
import Materials from './pages/Materials';
import Items from './pages/Items';
import PackCalculator from './pages/PackCalculator';
import EventCalc from './pages/EventCalc';
import SmeltingCalc from './pages/SmeltingCalc';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/config" replace />} />
          <Route path="config" element={<Config />} />
          <Route path="materials" element={<Materials />} />
          <Route path="items" element={<Items />} />
          <Route path="smelting" element={<SmeltingCalc />} />
          <Route path="calculator" element={<PackCalculator />} />
          <Route path="event-calc" element={<EventCalc />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;